<div class="content">
  <mat-tab-group
    class="first-tab-group"
    dynamicHeight
    fitInkBarToContent
    mat-stretch-tabs="false"
    mat-align-tabs="center"
    [preserveContent]="true"
    [animationDuration]="0"
    [selectedIndex]="index"
    (selectedIndexChange)="onIndexChange($event)"
  >
    <mat-tab *ngFor="let c of categories; let i = index">
      <ng-template mat-tab-label>
        <app-image
          [fileid]="c.icon"
          style="height: 64px; width: 64px; margin-right: 20px"
        ></app-image>
        {{ c.name }}
      </ng-template>
      <ng-template matTabContent>
        <mat-tab-group
          class="second-tab-group"
          dynamicHeight
          fitInkBarToContent
          mat-stretch-tabs="false"
          mat-align-tabs="center"
          [preserveContent]="true"
          [animationDuration]="0"
          [selectedIndex]="subIndex"
          (selectedIndexChange)="onSubIndexChange($event)"
        >
          <mat-tab *ngFor="let s of c.subCategories">
            <ng-template mat-tab-label>
              {{ s.name }}
            </ng-template>
            <ng-template matTabContent>
              <app-platform-list [categoryID]="s.id" [platforms]="s.platforms">
              </app-platform-list>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>

<div class="background">
  <div class="cover"></div>
</div>
